<template>
  <div class="miniPicture" v-show="show">
    <img @click="close()" src="@assets/img/common/close.svg" alt="close" class="close">
    <video ref="video" class="video" :src="src" controls=false controlsList="nodownload noremote footbar" contextmenu="none"></video>
  </div>
</template>

<script>
export default {
  name: 'miniPicture',
  data() {
    return {
      show: true,
      src: ''
    }
  },
  methods: {
    open(src) {
      this.src = src
      this.show = true
      this.$nextTick(() => {
        this.$refs.video.oncontextmenu = function(event) {
          return false
        }
      })
    },
    close() {
      this.show = false
      this.src = ''
    }
  }
}
</script>

<style lang="less" scoped>
  .miniPicture {
    position: fixed;
    right: 0;
    bottom: 0;
    height: 309px;
    width: 550px;
    color: #fff;
    border-radius: 4px;
    z-index: 1000;
    .close {
      position: absolute;
      right: 10px;
      top: 10px;
      cursor: pointer;
      z-index: 2;
    }
    .video {
      width: 100%;
      max-height: 100%;
      background-color: rgba(0, 0, 0, 0.8);
      color: #fff;
      font-size: 14px;
    }
  }
</style>
